module.exports = __webpack_public_path__ + "img/features-waiting.14c121cf.svg";